module.exports = __webpack_public_path__ + "media/images/athletes/516-01124596a01bfdc664f18c5ec0bb9f7b.png";